// import React, { useState, useEffect } from 'react';
// import {
//   Box, Button, Container, Paper, TextField, Typography,
//   Alert, CircularProgress, Chip, Grid, IconButton, Tab, Tabs
// } from '@mui/material';
// import { Refresh as RefreshIcon, AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';

// const AIContentGenerator = () => {
//   const [topic, setTopic] = useState('');
//   const [category, setCategory] = useState('For Hosts');
//   const [loading, setLoading] = useState(false);
//   const [generatedPost, setGeneratedPost] = useState(null);
//   const [message, setMessage] = useState(null);
//   const [topics, setTopics] = useState([]);
//   const [tabValue, setTabValue] = useState(0);

//   useEffect(() => {
//     fetchTopics();
//   }, []);

//   const fetchTopics = async () => {
//     try {
//       const response = await fetch('http://localhost:3001/api/ai/topics');
//       const data = await response.json();
//       setTopics(data.topics);
//     } catch (error) {
//       console.error('Failed to fetch topics:', error);
//     }
//   };

//   const handleGenerate = async () => {
//     if (!topic) {
//       setMessage({ type: 'error', text: 'Please enter a topic' });
//       return;
//     }

//     setLoading(true);
//     setMessage(null);

//     try {
//       const response = await fetch('http://localhost:3001/api/ai/generate', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ topic, category }),
//       });

//       const data = await response.json();
      
//       if (data.success) {
//         setGeneratedPost(data.post);
//         setMessage({ type: 'success', text: 'Post generated successfully! Review and publish.' });
//         setTopic('');
//       } else {
//         setMessage({ type: 'error', text: data.error || 'Failed to generate' });
//       }
//     } catch (error) {
//       setMessage({ type: 'error', text: 'Failed to connect to AI server. Make sure it\'s running on port 3001' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePublish = () => {
//     const savedPosts = localStorage.getItem('freshsweeper_blog_posts');
//     const posts = savedPosts ? JSON.parse(savedPosts) : [];
//     posts.unshift({ ...generatedPost, id: Date.now() });
//     localStorage.setItem('freshsweeper_blog_posts', JSON.stringify(posts));
//     setMessage({ type: 'success', text: 'Post published to blog!' });
//     setGeneratedPost(null);
//     setTimeout(() => setMessage(null), 3000);
//   };

//   const handleTopicClick = (selectedTopic) => {
//     setTopic(selectedTopic);
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Typography variant="h4" gutterBottom fontWeight="800" display="flex" alignItems="center" gap={1}>
//         <AutoAwesomeIcon sx={{ color: '#f59e0b' }} />
//         AI Content Generator
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
//         Generate SEO-optimized blog posts using Google's Gemini AI. Review, edit, and publish with one click.
//       </Typography>

//       {message && (
//         <Alert severity={message.type} sx={{ mb: 3 }} onClose={() => setMessage(null)}>
//           {message.text}
//         </Alert>
//       )}

//       <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ mb: 3 }}>
//         <Tab label="Generate New Post" />
//         <Tab label="Suggested Topics" />
//       </Tabs>

//       {tabValue === 0 && (
//         <Grid container spacing={4}>
//           <Grid item xs={12} md={4}>
//             <Paper sx={{ p: 3 }}>
//               <Typography variant="h6" fontWeight="600" gutterBottom>
//                 Content Settings
//               </Typography>
              
//               <TextField
//                 fullWidth
//                 label="Topic / Keyword"
//                 value={topic}
//                 onChange={(e) => setTopic(e.target.value)}
//                 placeholder="e.g., How to prepare your Airbnb for guest arrivals"
//                 multiline
//                 rows={2}
//                 sx={{ mb: 2 }}
//               />
              
//               <TextField
//                 fullWidth
//                 select
//                 label="Category"
//                 value={category}
//                 onChange={(e) => setCategory(e.target.value)}
//                 SelectProps={{ native: true }}
//                 sx={{ mb: 3 }}
//               >
//                 <option value="For Hosts">For Hosts</option>
//                 <option value="For Cleaners">For Cleaners</option>
//                 <option value="General">General</option>
//               </TextField>
              
//               <Button
//                 fullWidth
//                 variant="contained"
//                 onClick={handleGenerate}
//                 disabled={loading}
//                 startIcon={<AutoAwesomeIcon />}
//                 sx={{ py: 1.5 }}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Generate Article'}
//               </Button>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={8}>
//             {generatedPost && (
//               <Paper sx={{ p: 3 }}>
//                 <Typography variant="h5" fontWeight="700" gutterBottom>
//                   {generatedPost.title}
//                 </Typography>
                
//                 <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//                   <Chip label={generatedPost.category} size="small" />
//                   <Chip label="AI Generated" size="small" variant="outlined" />
//                   <Chip label="Draft" size="small" color="warning" />
//                 </Box>
                
//                 <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                   {generatedPost.excerpt}
//                 </Typography>
                
//                 <Box sx={{ 
//                   maxHeight: 400, 
//                   overflow: 'auto', 
//                   bgcolor: '#f5f5f5', 
//                   p: 2, 
//                   borderRadius: 2,
//                   mb: 2,
//                   '& h2': { fontSize: '1.3rem', fontWeight: 600, mt: 2, mb: 1 },
//                   '& h3': { fontSize: '1.1rem', fontWeight: 600, mt: 1.5, mb: 0.5 },
//                   '& p': { mb: 1 },
//                   '& .tip': { bgcolor: '#e3f2fd', p: 2, borderRadius: 2, my: 2 }
//                 }}>
//                   <div dangerouslySetInnerHTML={{ __html: generatedPost.content }} />
//                 </Box>
                
//                 <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
//                   <Button variant="contained" onClick={handlePublish} startIcon={<AutoAwesomeIcon />}>
//                     Publish to Blog
//                   </Button>
//                   <Button variant="outlined" onClick={() => setGeneratedPost(null)}>
//                     Discard
//                   </Button>
//                 </Box>
//               </Paper>
//             )}
//           </Grid>
//         </Grid>
//       )}

//       {tabValue === 1 && (
//         <Grid container spacing={2}>
//           {topics.map((suggestedTopic, idx) => (
//             <Grid item xs={12} sm={6} md={4} key={idx}>
//               <Paper 
//                 sx={{ p: 2, cursor: 'pointer', '&:hover': { bgcolor: '#f5f5f5' } }}
//                 onClick={() => {
//                   setTopic(suggestedTopic);
//                   setTabValue(0);
//                 }}
//               >
//                 <Typography variant="body2" fontWeight="500">
//                   {suggestedTopic}
//                 </Typography>
//               </Paper>
//             </Grid>
//           ))}
//         </Grid>
//       )}
//     </Container>
//   );
// };

// export default AIContentGenerator;





import React, { useState, useEffect } from 'react';
import {
  Box, Button, Container, Paper, TextField, Typography,
  Alert, CircularProgress, Chip, Grid, Tab, Tabs, Stack
} from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';

const API_URL = 'http://localhost:3001';

const AIContentGenerator = () => {
  const [topic, setTopic] = useState('');
  const [category, setCategory] = useState('For Hosts');
  const [loading, setLoading] = useState(false);
  const [generatingTopics, setGeneratingTopics] = useState(false);
  const [generatedTopics, setGeneratedTopics] = useState([]);
  const [generatedPost, setGeneratedPost] = useState(null);
  const [message, setMessage] = useState(null);
  const [topics, setTopics] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    fetchTopics();
  }, []);

  const fetchTopics = async () => {
    try {
      const response = await fetch(`${API_URL}/api/ai/topics`);
      const data = await response.json();
      setTopics(data.topics || []);
    } catch (error) {
      console.error('Failed to fetch topics:', error);
    }
  };

  const generateTopics = async () => {
    setGeneratingTopics(true);
    setMessage({ type: 'info', text: '🤖 Generating topic ideas...' });
    
    try {
      const response = await fetch(`${API_URL}/api/ai/generate-topics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category, count: 10 }),
      });
      
      const data = await response.json();
      if (data.success) {
        setGeneratedTopics(data.topics);
        setMessage({ type: 'success', text: `✨ Generated ${data.topics.length} topic ideas!` });
      } else {
        setMessage({ type: 'error', text: 'Failed to generate topics' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Error generating topics' });
    } finally {
      setGeneratingTopics(false);
      setTimeout(() => setMessage(null), 3000);
    }
  };

  const handleGenerate = async () => {
    if (!topic) {
      setMessage({ type: 'error', text: 'Please enter a topic or generate one' });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch(`${API_URL}/api/ai/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic, category }),
      });

      const data = await response.json();
      
      if (data.success) {
        setGeneratedPost(data.post);
        setMessage({ type: 'success', text: '✨ Post generated successfully!' });
        setGeneratedTopics([]);
      } else {
        setMessage({ type: 'error', text: data.error || 'Failed to generate' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Cannot connect to AI server. Make sure it\'s running on port 3001' });
    } finally {
      setLoading(false);
    }
  };

  const handlePublish = () => {
    const savedPosts = localStorage.getItem('freshsweeper_blog_posts');
    const posts = savedPosts ? JSON.parse(savedPosts) : [];
    const newPost = { ...generatedPost, id: Date.now() };
    posts.unshift(newPost);
    localStorage.setItem('freshsweeper_blog_posts', JSON.stringify(posts));
    setMessage({ type: 'success', text: '🎉 Post published to blog!' });
    setGeneratedPost(null);
    setTopic('');
    setTimeout(() => setMessage(null), 3000);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom fontWeight="800" display="flex" alignItems="center" gap={1}>
        <AutoAwesomeIcon sx={{ color: '#f59e0b' }} />
        AI Content Generator
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Generate blog topics and SEO-optimized posts using AI. Review and publish with one click.
      </Typography>

      {message && (
        <Alert severity={message.type} sx={{ mb: 3 }} onClose={() => setMessage(null)}>
          {message.text}
        </Alert>
      )}

      <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ mb: 3 }}>
        <Tab label="Generate New Post" />
        <Tab label="Suggested Topics" />
      </Tabs>

      {tabValue === 0 && (
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" fontWeight="600" gutterBottom>
                Content Settings
              </Typography>
              
              <Button
                fullWidth
                variant="outlined"
                onClick={generateTopics}
                disabled={generatingTopics}
                startIcon={<AutoAwesomeIcon />}
                sx={{ mb: 2 }}
              >
                {generatingTopics ? <CircularProgress size={24} /> : '✨ Generate Topic Ideas'}
              </Button>
              
              {generatedTopics.length > 0 && (
                <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                  <Typography variant="subtitle2" fontWeight="600" gutterBottom>
                    Suggested Topics:
                  </Typography>
                  <Stack spacing={1}>
                    {generatedTopics.map((genTopic, idx) => (
                      <Button
                        key={idx}
                        variant="text"
                        size="small"
                        onClick={() => {
                          setTopic(genTopic);
                          setGeneratedTopics([]);
                        }}
                        sx={{ justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none', p: 0.5 }}
                      >
                        • {genTopic}
                      </Button>
                    ))}
                  </Stack>
                </Box>
              )}
              
              <TextField
                fullWidth
                label="Topic / Keyword"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                placeholder="e.g., How to prepare your Airbnb for guest arrivals"
                multiline
                rows={2}
                sx={{ mb: 2 }}
              />
              
              <TextField
                fullWidth
                select
                label="Category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                SelectProps={{ native: true }}
                sx={{ mb: 3 }}
              >
                <option value="For Hosts">For Hosts</option>
                <option value="For Cleaners">For Cleaners</option>
                <option value="General">General</option>
              </TextField>
              
              <Button
                fullWidth
                variant="contained"
                onClick={handleGenerate}
                disabled={loading}
                startIcon={<AutoAwesomeIcon />}
                sx={{ py: 1.5 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Generate Article'}
              </Button>
            </Paper>
          </Grid>

          <Grid item xs={12} md={8}>
            {generatedPost && (
              <Paper sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight="700" gutterBottom>
                  {generatedPost.title}
                </Typography>
                
                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                  <Chip label={generatedPost.category} size="small" />
                  <Chip label="AI Generated" size="small" variant="outlined" />
                  <Chip label="Draft - Ready to Publish" size="small" color="warning" />
                </Box>
                
                {generatedPost.imageUrl && (
                  <Box
                    component="img"
                    src={generatedPost.imageUrl}
                    alt={generatedPost.title}
                    sx={{ width: '100%', borderRadius: 2, mb: 2, maxHeight: 300, objectFit: 'cover' }}
                  />
                )}
                
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  <strong>Excerpt:</strong> {generatedPost.excerpt}
                </Typography>
                
                <Box sx={{ 
                  maxHeight: 400, 
                  overflow: 'auto', 
                  bgcolor: '#fafafa', 
                  p: 2, 
                  borderRadius: 2,
                  mb: 2,
                  border: '1px solid #e0e0e0'
                }}>
                  <div dangerouslySetInnerHTML={{ __html: generatedPost.content }} />
                </Box>
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="contained" onClick={handlePublish} startIcon={<AutoAwesomeIcon />}>
                    Publish to Blog
                  </Button>
                  <Button variant="outlined" onClick={() => setGeneratedPost(null)}>
                    Discard
                  </Button>
                </Box>
              </Paper>
            )}
          </Grid>
        </Grid>
      )}

      {tabValue === 1 && (
        <Grid container spacing={2}>
          {topics.map((suggestedTopic, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Paper 
                sx={{ 
                  p: 2, 
                  cursor: 'pointer', 
                  transition: 'all 0.2s',
                  '&:hover': { 
                    bgcolor: '#f5f5f5',
                    transform: 'translateY(-2px)',
                  } 
                }}
                onClick={() => {
                  setTopic(suggestedTopic);
                  setTabValue(0);
                }}
              >
                <Typography variant="body2" fontWeight="500">
                  💡 {suggestedTopic}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default AIContentGenerator;
